export const POPUPS = {
    STATE_SELECTOR: 'stateSelector',
    MOMENTUM_LOYALTY: 'momentumLoyalty',
    LOGOUT: 'logout',
    EXCLUSIVE_ZONE: 'exclusiveZone',
    GAME_INFO: 'gameInfo',
    SWJ_OPT_IN: 'swjOptIn',
    SWJ_ERROR: 'swjError',
    DYB_INTERSTITIAL: 'dybInterstitial',
    REWARD_MACHINE_WELCOME_MODAL: 'rewardMachineWelcomeModal',
    VOLATILITY_INFO: 'volatilityInfo',
    BIGGEST_WIN: 'biggestWin'
};

export const POPUP_ERROR_CODES = {
    OPT_IN_FAILED: 'SWJ-005',
    OPT_OUT_FAILED: 'SWJ-006'
};

export type PopupType = (typeof POPUPS)[keyof typeof POPUPS];
